import { render, staticRenderFns } from "./CreateTasks.vue?vue&type=template&id=e5398912&scoped=true&"
import script from "./CreateTasks.vue?vue&type=script&lang=js&"
export * from "./CreateTasks.vue?vue&type=script&lang=js&"
import style0 from "./CreateTasks.vue?vue&type=style&index=0&id=e5398912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5398912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSlideXTransition})
